import React from 'react';
import {Drawer, DrawerCloseButtonProps} from '@mantine/core';

export const EtroDrawerCloseButton: React.FC<DrawerCloseButtonProps> = props => {
  return <Drawer.CloseButton {...props} />;
};
